<template>
  <div class="body-info">
    <Popup v-model="showPopupCashier" position="bottom" :closeable="true" class="popup-body">
      <PayCard :refer="referInfo" :scene="sceneInfo"></PayCard>
    </Popup>
  </div>
</template>

<script>
  import {Popup} from "vant"
  import PayCard from "./PayCard";

  export default {
    name: "DonatePopup",
    components: {PayCard, Popup},
    props: {
      value: {
        type: Boolean,
        default: false,
      },
      refer: {
      },
      scene: {
        type: String,
        value: "",
      }
    },
    data() {
      return {
        showPopupCashier: false,
        referInfo: "",
        sceneInfo: "",
      }
    },
    mounted() {
      this.showPopupCashier = this.value
      this.referInfo = this.refer
      this.sceneInfo = this.scene || ""
    },
    methods: {
    },
    computed: {
    },

    watch: {
      value(newVal, oldVal) {
        this.showPopupCashier = newVal
      },

      refer(newVal, oldVal) {
        this.referInfo = newVal
      },

      scene(newVal, oldVal) {
        this.sceneInfo = newVal
      },

      showPopupCashier(newVal, oldVal) {
        this.$emit('input', newVal);
      },
    }
  }
</script>

<style scoped lang="scss">

  .body-info {
    background: #f2f2f2;
  }

  .popup-body {
    padding-top: 22px;
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }

</style>
